import { DataGridProps } from '@mui/x-data-grid'
import { DataGridOverlay, DataGridToolbar } from 'shared/components'
import { ApolloError } from '@apollo/client'
import { useTranslation } from 'react-i18next'

export const useDataGrid = (
  error: ApolloError | undefined,
  pageSize: number,
  onPageSizeChange: (pageSize: number) => void,
  rowsPerPageOptions: number[],
  rowCount: number,
  page: number,
  onPageChange: (page: number) => void,
  query: string | null,
  setQuery: ((query: string) => void) | null,
  isLoading: boolean
) => {
  const { t } = useTranslation()

  const dataGridProps: Partial<DataGridProps> = {
    error: error?.message,
    pageSize,
    onPageSizeChange,
    hideFooterSelectedRowCount: true,
    pagination: true,
    paginationMode: 'server',
    loading: isLoading,
    localeText: {
      noRowsLabel: t('noResults'),
      noResultsOverlayLabel: t('noResults'),
    },
    rowsPerPageOptions,
    rowCount,
    page,
    onPageChange,
    components: {
      Toolbar: () =>
        query === null || setQuery === null ? null : (
          <DataGridToolbar
            searchQuery={query}
            onSearch={setQuery}
            isLoading={isLoading}
          />
        ),
      LoadingOverlay: () => <DataGridOverlay />,
    },
  }

  return { dataGridProps }
}
